<wiz-vgroup height="100%" width="100%" gap='-3'>
  <wiz-hgroup width="100%">
    <wiz-text-input #tiSearchFilter width="100%"
                    [wizLeftIcon]="'search'"
                    class="notBusinessComponent"
                    [wizPlaceholder]="'$.common.filter.prompt.$'"
                    [wizMaxChars]=20 [manageModel]=false
                    [wizShowClearButton]=true>
    </wiz-text-input>
    <wiz-button #btnShowMoreFilter width="100px"
                *ngIf="advancedMode"
                (click)="toggleShowMore()"
                class="hyperButton"
                [wizLabel]="showMoreLabel">
    </wiz-button>
  </wiz-hgroup>

  <wiz-hgroup width="100%" horizontalAlign="space-between">
    <wiz-button #btnResetFilter
                *ngIf="advancedMode && activeFilter"
                (click)="resetFilter()"
                class="hyperButton"
                [wizLabel]="'$.common.reset.filters.$'" >
    </wiz-button>
  </wiz-hgroup>
  <wiz-spacer height="5px"></wiz-spacer>
  <wiz-vgroup #vgMoreFilters [visible]="advancedMode && _isOpen"
              height="100%" width="100%"
              style="overflow: auto; padding-left: 10px; padding-right: 10px;">
    <ng-container #filterContainer></ng-container>
  </wiz-vgroup>

</wiz-vgroup>
